import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const DynamicTitleAndIcon = () => {
  const location = useLocation();

  const updateTitleAndIcon = (pathname) => {
    let title = 'Amsha - Dashboard';
    let iconPath = ".\assets\images\logo.png";

    switch (pathname) {    
      case '/booking':
        title = 'Amsha - Booking';
        iconPath = {iconPath}
        break;
          case '/partner':
        title = 'Amsha - Partner List';
        iconPath = {iconPath}
        break;
          case '/kyc':
        title = 'Amsha - KYC ';
        iconPath = {iconPath}
        break;
      case '/login':
            title = 'Amsha - Login';
            iconPath = {iconPath}
            break;
     
     
      default:
        title = 'Amsha - Dashboard';
    }

    const favicon = document.getElementById('favicon');
    if (favicon) {
      favicon.href = iconPath;
    }

    document.title = title;
  };

  useEffect(() => {
    updateTitleAndIcon(location.pathname);
  }, [location.pathname]);

  return null; 
};

export default DynamicTitleAndIcon;
